// initial state
const state = () => ({
  text: "",
  color: "",
  display: undefined,
});

// actions
const actions = {
  async showError({ commit }, message) {
    commit("SET_ERROR", message);
  },
  async showSuccess({ commit }, message) {
    commit("SET_SUCCESS", message);
  },
  closeSnackbar({ commit }) {
    commit("SET_DISPLAY_SNACKBAR", false);
  },
};

// mutations
const mutations = {
  SET_ERROR(state, message) {
    state.text = message;
    state.color = "error";
    state.display = true;
  },
  SET_SUCCESS(state, message) {
    state.text = message;
    state.color = "success";
    state.display = true;
  },
  SET_DISPLAY_SNACKBAR(state, display) {
    state.display = display;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
